import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Link, 
  Stack
} from '@mui/material';
import { useContext } from 'react';
import { StoreContext } from '../App';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const storeContext = useContext(StoreContext);
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#2e7d32',
        color: 'white',
        pt: 3,
        pb: 3,
        mt: 'auto',
        width: '100%',
        position: 'static',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'center', md: 'flex-start' },
          gap: 2
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <CopyrightIcon sx={{ fontSize: 16, mr: 0.5 }} />
            <Typography variant="body2">
              {currentYear} {storeContext.name}. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 